const DocPermissionEnum = Object.freeze({
  DOC_OWN: 'doc-own',
  DOC_VIEW: 'doc-view',
  DOC_EDIT: 'doc-edit',
  DOC_DOWNLOAD: 'doc-download'
});

export default DocPermissionEnum;
